import { render, staticRenderFns } from "./HomeHeader.vue?vue&type=template&id=31fae24e&scoped=true&"
import script from "./HomeHeader.vue?vue&type=script&lang=js&"
export * from "./HomeHeader.vue?vue&type=script&lang=js&"
import style0 from "./HomeHeader.vue?vue&type=style&index=0&id=31fae24e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fae24e",
  null
  
)

export default component.exports